import { useCallback } from 'react'
import type { MouseEvent } from 'react'
import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import TextLink from 'LuxKit/TextLink'
import { consentMessages } from '../../../lib/consent/messages'
import { openCookieSettings } from '../../consent/openSettings'
import { useCookieSettingsLinkVisible } from '../../consent/useCookieSettingsLinkVisible'
import FooterListItem from '../App/Footer/FooterListItem'

interface Props {
  variant: 'list' | 'inline' | 'header'
}

const COOKIE_SETTINGS_HREF = '#cookie-settings'

function CookieSettingsLink({ variant }: Props) {
  const intl = useIntl()
  const isVisible = useCookieSettingsLinkVisible()
  const label = intl.formatMessage(consentMessages.cookieSettings)

  const onClick = useCallback((event: MouseEvent<HTMLElement>) => {
    event.preventDefault()
    openCookieSettings()
  }, [])

  if (!isVisible) return undefined

  if (variant === 'list') {
    return <FooterListItem title={label} href={COOKIE_SETTINGS_HREF} onClick={onClick} />
  }

  return (
    <BodyText variant={variant === 'header' ? 'medium' : 'large'}>
      <TextLink
        href={COOKIE_SETTINGS_HREF}
        onClick={onClick}
        size={variant === 'header' ? 'medium' : 'large'}
        weight="regular"
        underline={false}
      >
        {label}
      </TextLink>
    </BodyText>
  )
}

export default CookieSettingsLink
